import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./ImageSlider.scss";
import "./slick.css";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 769);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
};

const Video = ({ visible, src }) => {
  const videoRef = React.useRef();
  React.useEffect(() => {
    if (videoRef.current) {
      if (visible) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [visible, src]);
  return (
    <video ref={videoRef} muted loop preload="auto" src={src} width="100%" />
  );
};

export default function App({ images }) {
  const settings = {
    infinite: true,
    speed: 1000,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    waitForAnimate: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    swipe: false,
  };

  const [currentSlide, setCurrentSlide] = useState(0);

  const isMobile = useIsMobile();

  return (
    <div className="img-container">
      <Slider
        {...settings}
        afterChange={(current) => {
          setCurrentSlide(current);
        }}
      >
        {images.map(([src, smallSrc], index) => {
          if (src.includes(".mp4")) {
            return (
              <Video
                src={isMobile ? smallSrc : src}
                key={`${index}-${isMobile ? smallSrc : src}`}
                visible={index === currentSlide}
              />
            );
          }
          return (
            <img
              src={isMobile ? smallSrc : src}
              key={isMobile ? smallSrc : src}
            />
          );
        })}
      </Slider>
    </div>
  );
}
